import DOMPurify from "dompurify";

// monday update/reply bodies are rich-text HTML authored by users across boards.
// Allowlist monday's actual rich-text tag set; DOMPurify strips on* handlers and
// javascript:/data: URLs by default.
export const sanitizeBody = (html: string): string =>
  DOMPurify.sanitize(html ?? "", {
    ALLOWED_TAGS: ["b", "strong", "i", "em", "u", "a", "br", "p", "span", "ul", "ol", "li", "img"],
    ALLOWED_ATTR: [
      "href", "target", "rel", "src", "alt",
      "class", "data-mention-id", "data-mention-type",
    ],
    ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|\/)/i,
  });
